import { pauseClock } from '../../core/pause';

/** Pausable delay — freezes while the scenario is paused. */
export function wait(ms: number): Promise<void> {
  return pauseClock.wait(ms);
}
